export default `float s=1., e, offset=0.26; 
    for(int i=0;i++<5;){
      s*=e=2./min(dot(p,p),1.);
      p=abs(p)*e-vec3(1.0,10.*offset,1.0);
    }
    return length(max(abs(p)-1.,0.))/s;
  }`